import {
  ISipClientReasonCreateProps,
  ISipClientReasonProps,
  ISipClientReasonSimpleProps,
  ISipClientReasonUpdateParams,
} from './types';
import { api } from '../DefaultService';
import { IPaginationParams } from '../types';

export const ENDPOINT_SIP_CLIENT_REASON = 'v1/sipClientReasons';

export const createSipClientReasonAsync = async (
  data: ISipClientReasonCreateProps,
): Promise<ISipClientReasonProps> => {
  return await api
    .post(ENDPOINT_SIP_CLIENT_REASON, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSipClientReasonByIdAsync = async (
  id: number,
): Promise<ISipClientReasonProps> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT_REASON}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSipClientReasonByLicenseAsync = async (
  pagination?: IPaginationParams,
): Promise<ISipClientReasonSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT_REASON}/getAllByLicense`, {
      params: { pagination },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
export const getAllSipClientReasonByLicenseCountAsync =
  async (): Promise<number> => {
    return await api
      .get(`${ENDPOINT_SIP_CLIENT_REASON}/getAllByLicense/count`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const updateSipClientReasonAsync = async ({
  id,
  data,
}: ISipClientReasonUpdateParams): Promise<ISipClientReasonProps> => {
  return await api
    .put(`${ENDPOINT_SIP_CLIENT_REASON}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteSipClientReasonAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT_SIP_CLIENT_REASON}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
